import React from 'react'
import {connect} from 'react-redux';
import Staff from './staff'
import AddStaff from './add-staff'
import EditStaff from './edit-staff'
import {resendInvitation, getStaffMember, addStaff} from '../../actions/staff'

const StaffList = (props) => {
  const onAddStaffClicked = (row) => {
    props.dispatch(addStaff())
      .then(() => {
        props.dispatch({type: 'SHOW_EDIT_STAFF', show: -1, payLoad: {id: -1}});
      });
  };

  const onResendClicked = (link) => {
    props.dispatch(resendInvitation(link));
  };

  const onEditStaffClicked = (link, row, status, id) => {
    if(props.staff_member_id !== id){
      props.dispatch(addStaff(link));
      props.dispatch(getStaffMember(link, row, status));
    }
  };

  let staffItems = [<h1>Loading...</h1>];

  if (props.fetched) {
    staffItems = [[]];

    props.staff.forEach((staff, index)=> {
      if(index > 0 && !(index % 3)){
        staffItems.push([]);
      }
      staffItems[staffItems.length-1].push(
        <Staff
          key={staff.id}
          staff={staff}
          row={staffItems.length-1}
          open={props.staff_member_id === staff.id}
          onEditStaffClicked={onEditStaffClicked}
          onResendClicked={onResendClicked}/>
      )
    });

    if(!(staffItems[staffItems.length-1].length % 3)){
      staffItems.push([]);
    }

    staffItems.push([
      <AddStaff key="-1"
        onAddStaffClicked={onAddStaffClicked}
        open={props.staff_member_id === -1}
        row={staffItems.length - 1}
      />
    ]);
  }

  return (
    <div className="staff-list">
      {staffItems.map((item, arrayIndex) => {

        let index = item[0] && item[0].key == -1 ? -1 : arrayIndex
        return (
          <div key={`container-${index}`}>
            <div className={`row row-${index} smrow-${props.staff_member_row}`} key={`row-${index}`}>
              {item}
            </div>
            <div className={`row row-${index} editsmrow-${props.staff_member_row}`} key={`edit-${index}`}>
              {index === props.staff_member_row && <EditStaff open={index === props.staff_member_row }/>}
            </div>
          </div>
        )
      })}
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    editStaffVisible: state.staff.editStaffVisible,
    staff_member_id: state.staff.staff_member_id,
    staff_member_row: state.staff.staff_member_row
  };
};

export default connect(mapStateToProps)(StaffList);



// WEBPACK FOOTER //
// ./src/components/my-staff/staff-list.jsx